/**
 *  @fileOverview Youtube module, initalises youtube instances https://github.com/gajus/youtube-player
 *
 *  @author       Chris Hill
 *
 */

function YoutubeModule (YouTubePlayer) {
  /**
   * @description Initialises youtube api when videoResponsive divs are found.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Define vars
     */
    const videos = document.querySelectorAll('.videoResponsive')
    const url = document.location.href
    const title = document.title
    window.dataLayer = window.dataLayer || []

    /**
     * Loop through divs that will load youtube videos
     */
    videos.forEach((video, index) => {
      if (typeof video.dataset.videoid !== 'undefined') {
        const id = 'ecu-yt-' + index
        const vid = video.dataset.videoid
        const getUrl = window.location
        const baseUrl = getUrl.protocol + '//' + getUrl.host
        let vars = {
          rel: 0,
          origin: baseUrl,
          host: baseUrl
        }

        /**
         * Check for playlist param and add to vars
         */
        if (typeof video.dataset.playlistid !== 'undefined') {
          vars.listType = 'playlist'
          vars.list = video.dataset.playlistid
        }

        /**
         * Create new div to load vidoe over the top of
         */
        let div = document.createElement('div')
        div.id = id

        video.appendChild(div)

        /**
         * Initialise the YT player
         */
        let player = YouTubePlayer(id, {
          videoId: vid,
          playerVars: vars
        })

        let timer = null

        /**
         * Check player status on change 0 = stopped, 1 = playing, 2 = paused
         */
        player.on('stateChange', function (event) {
          const status = event.data
          if (status === 0) {
            /**
             * Trigger GTM event for stop/ended
             */
            window.dataLayer.push({
              'event': 'gtm-youtube-stopped',
              'page-url': url,
              'page-title': title,
              'video-id': vid
            })

            window.clearInterval(timer)
          } else if (status === 1) {
            /**
             * Trigger GTM event for play
             */
            window.dataLayer.push({
              'event': 'gtm-youtube-play',
              'page-url': url,
              'page-title': title,
              'video-id': vid
            })

            /**
             * Call GTM if video has played for 15 seconds without being paused or stopped
             */
            timer = window.setTimeout(function () {
              window.dataLayer.push({
                'event': 'gtm-youtube-15s',
                'page-url': url,
                'page-title': title,
                'video-id': vid
              })
            }, 15000)
          } else if (status === 2) {
            /**
             * Trigger GTM event for paused
             */
            window.dataLayer.push({
              'event': 'gtm-youtube-paused',
              'page-url': url,
              'page-title': title,
              'video-id': vid
            })

            window.clearInterval(timer)
          }
        })

        /**
         * Listen for event from sliderModule
         */
        window.addEventListener('pauseyoutube', e => {
          /**
           * Check if the player is inside the slider that emitted the event and pause if so
           */
          const parent = video.closest('#' + e.detail)

          if (parent !== null) {
            player.pauseVideo()
          }
        })
      }
    })
  }
}

module.exports = YoutubeModule
